/**
 * Circular brand logo for Cafe Hideout.
 * Curved "CAFE HIDEOUT" text around a coffee cup mark.
 * Two variants via the `tone` prop: "cream" (light text on dark) or "coffee" (dark text on cream).
 */
export default function CafeHideoutLogo({ size = 84, tone = "cream", className = "" }) {
    const fg = tone === "cream" ? "#f5e6c8" : "#1a0f00";
    const accent = "#c5a059";
    const bg = "transparent";

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 200 200"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            aria-label="Cafe Hideout"
            role="img"
        >
            <defs>
                <path
                    id="ch-arc-top"
                    d="M 30,100 A 70,70 0 0 1 170,100"
                    fill="none"
                />
                <path
                    id="ch-arc-bottom"
                    d="M 35,108 A 65,65 0 0 0 165,108"
                    fill="none"
                />
            </defs>

            {/* outer ring */}
            <circle cx="100" cy="100" r="94" fill={bg} stroke={fg} strokeWidth="1.5" />
            {/* inner ring */}
            <circle cx="100" cy="100" r="78" fill={bg} stroke={fg} strokeWidth="0.7" opacity="0.7" />

            {/* curved CAFE HIDEOUT text */}
            <text fill={fg} style={{ fontFamily: "Poppins, sans-serif", fontWeight: 600, fontSize: "11.5px", letterSpacing: "3.8px" }}>
                <textPath href="#ch-arc-top" startOffset="50%" textAnchor="middle">
                    CAFE • HIDEOUT
                </textPath>
            </text>

            {/* curved EST text bottom */}
            <text fill={fg} style={{ fontFamily: "Poppins, sans-serif", fontWeight: 400, fontSize: "8px", letterSpacing: "5px" }} opacity="0.85">
                <textPath href="#ch-arc-bottom" startOffset="50%" textAnchor="middle">
                    EST • 2018 • INDIA
                </textPath>
            </text>

            {/* central coffee cup mark */}
            <g transform="translate(100,100)" stroke={fg} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" fill="none">
                {/* cup body */}
                <path d="M -22,-6 L -22,12 A 10,10 0 0 0 -12,22 L 12,22 A 10,10 0 0 0 22,12 L 22,-6 Z" />
                {/* handle */}
                <path d="M 22,-2 A 9,9 0 0 1 22,16" />
                {/* saucer */}
                <line x1="-28" y1="28" x2="28" y2="28" />
                {/* steam */}
                <path d="M -8,-12 C -10,-16 -6,-18 -8,-22" opacity="0.85" />
                <path d="M 0,-12 C -2,-16 2,-18 0,-22" opacity="0.85" />
                <path d="M 8,-12 C 6,-16 10,-18 8,-22" opacity="0.85" />
            </g>

            {/* tiny accent dots flanking the cup */}
            <circle cx="40" cy="100" r="2" fill={accent} />
            <circle cx="160" cy="100" r="2" fill={accent} />
        </svg>
    );
}
